import {Locale} from './locale';

export const getCustomerEmailByLocale = (locale: Locale) => {
  switch (locale) {
    case Locale.en_ZZ:
      return 'customerservice@aboutyou.com';
    case Locale.en_DE:
      return 'customerservice@aboutyou.de';
    case Locale.de_DE:
      return 'kundenservice@aboutyou.de';
    case Locale.da_DK:
      return 'kundeservice@aboutyou.dk';
    case Locale.de_CH:
      return 'kundenservice@aboutyou.ch';
    case Locale.de_AT:
      return 'kundenservice@aboutyou.at';
    case Locale.en_AT:
      return 'customerservice@aboutyou.at';
    case Locale.bg_BG:
      return 'obsluzhvanenaklienti@aboutyou.bg';
    case Locale.cs_CZ:
      return 'zakaznickyservis@aboutyou.cz';
    case Locale.el_CY:
      return 'customerservice@aboutyou.com.cy';
    case Locale.el_GR:
      return 'customerservice@aboutyou.gr';
    case Locale.es_ES:
      return 'atencionalcliente@aboutyou.es';
    case Locale.es_ZZ:
      return 'atencionalcliente@aboutyou.com';
    case Locale.et_EE:
      return 'klienditeenindus@aboutyou.ee';
    case Locale.fi_FI:
      return 'asiakaspalvelu@aboutyou.fi';
    case Locale.fr_BE:
      return 'serviceclients@aboutyou.be';
    case Locale.fr_LU:
      return 'serviceclients@aboutyou.lu';
    case Locale.fr_CH:
      return 'serviceclients@aboutyou.ch';
    case Locale.fr_FR:
      return 'serviceclients@aboutyou.fr';
    case Locale.hr_HR:
      return 'sluzbazakorisnike@aboutyou.hr';
    case Locale.hu_HU:
      return 'ugyfelszolgalat@aboutyou.hu';
    case Locale.it_CH:
      return 'servizioclienti@aboutyou.ch';
    case Locale.en_CH:
      return 'customerservice@aboutyou.ch';
    case Locale.it_IT:
      return 'servizioclienti@aboutyou.it';
    case Locale.lt_LT:
      return 'klientuaptarnavimas@aboutyou.lt';
    case Locale.lv_LV:
      return 'klientuapkalposana@aboutyou.lv';
    case Locale.nl_BE:
      return 'klantenservice@aboutyou.be';
    case Locale.nl_NL:
      return 'klantenservice@aboutyou.nl';
    case Locale.en_NL:
      return 'customerservice@aboutyou.nl';
    case Locale.pl_PL:
      return 'obslugaklienta@aboutyou.pl';
    case Locale.pt_PT:
      return 'apoioaocliente@aboutyou.pt';
    case Locale.ro_RO:
      return 'serviciu.clienti@aboutyou.ro';
    case Locale.ru_EE:
      return 'sluzhbapodderzhki@aboutyou.ee';
    case Locale.ru_LV:
      return 'sluzhbapodderzhki@aboutyou.lv';
    case Locale.sk_SK:
      return 'zakaznickyservis@aboutyou.sk';
    case Locale.sl_SI:
      return 'storitvezastranke@aboutyou.si';
    case Locale.sv_SE:
      return 'kundservice@aboutyou.com';
    default:
      return 'customerservice@aboutyou.de';
  }
};
